<template>
    <div>
        <header class="container-fluid" v-if="this.$route.path != '/'">
            <b-row>
                <b-col md="3" align-self="center">
                    <router-link to="/" class="hoya"><img src="img/hoya.png" alt="HOYA" class="img-responsive"/></router-link>
                </b-col> 
                <b-col md="7" align-self="center" >
                    <h1>2017 Global Leadership Group Meeting <b>5 Days 4 Nights Beijing</b></h1>
                </b-col>
            </b-row>
        </header>
    </div>
</template>

<script>

export default {
    name: 'AppHeader'
}
</script>

<style lang="less" scoped>
header {
    padding-bottom: 15px;
    padding-top: 15px;
    position: relative;
    
    h1 {
        font-size: 1.35em;
        line-height: 1.2;
        text-align: center;

		b {
			color: @grey;
			display: block;
			font-weight: normal;
		}
    }
    .hoya {	
        display: none;
    }
}



@media only screen and (min-width : 768px) {
    header {
        height: 150px;

        h1 {
            font-size: 2em;
        }
        .hoya {
            display: block;
        }
    }
    
}
</style>